import { useEffect, useState } from "react";

export const useTimestamp = (arg: any) => {
    const [tstamp, setTstamp] = useState(Date.now());
    useEffect(() => {
        setTstamp(Date.now());
    }, [arg]);
    return tstamp;
};
